import { Paper } from '@mantine/core';
import { featureCollection } from '@turf/turf';
import { MapEvent } from 'mapbox-gl';
import { FC, useState } from 'react';

import { SamplePopup, SamplePopupData } from '../../components/sample-popup';
import { useOrderPage } from '../../hooks/use-order-page';
import { flattenSamples } from '../../utils/flatten-samples';

import {
  PfMap,
  SamplesLayerProps,
  SamplesLayers,
  ZoningLayer,
  zoomOnFeature,
} from '@map';

export const OrderMapPage: FC = () => {
  const { order } = useOrderPage();
  const [popupData, setPopupData] = useState<SamplePopupData | null>(null);

  const samples = flattenSamples(order.data.samples);

  const handleLoad = (map: MapEvent) => {
    if (order.data?.map.features.length) {
      zoomOnFeature({
        map: map.target,
        geojson: order.data?.map,
      });
    }
  };

  const handleMarkerClick: SamplesLayerProps['onClick'] = ({
    id: featureId,
    lngLat,
  }) => {
    const sample = samples.find((f) => f.id === featureId);
    setPopupData({
      longitude: lngLat.lng,
      latitude: lngLat.lat,
      code: sample?.properties.code || '',
      status: sample?.properties.status || null,
      fieldName: sample?.properties.field_name || null,
    });
  };

  return (
    <Paper h="100%" p={0} radius="sm" withBorder>
      <PfMap onLoad={handleLoad}>
        {order.data?.map ? <ZoningLayer data={order.data?.map} /> : null}
        {samples.length ? (
          <SamplesLayers
            data={featureCollection(samples)}
            key={`samples-layer`}
            layerId={`samples-layer`}
            onClick={handleMarkerClick}
            size={30}
            sourceId={`samples-layer`}
            withLabel
          />
        ) : null}

        {popupData && (
          <SamplePopup data={popupData} onClose={() => setPopupData(null)} />
        )}
      </PfMap>
    </Paper>
  );
};
